<template>
    <div
        v-if="render"
        class="fixed top-0 left-0 h-full w-screen z-40 transition-all"
        :class="{'visible' : show, 'invisible': !show}"
    >
        <div
            class="absolute h-full w-full bg-darkblue-800 duration-500 transition-all"
            :class="{ 'opacity-50' : show , 'opacity-0' : !show}"
            @click="$emit('close')"
        ></div>
        
        <div
            class="absolute bottom-0 w-full bg-white h-[calc(var(--vh,1vh)*100-max(91px,7%))] transition-all duration-500 lg:w-[545px] lg:h-screen mlg:w-[720px]"
            :class="{ 'right-0' : show, '-right-full lg:-right-1/2' : !show, 'first-open': firstRender && show }"
        >
            <div class="flex h-full px-5 flex-col bg-white shadow-xl md:px-10">
                <h2
                    class="flex items-center align-baseline font-bold text-blue cursor-pointer py-3 mb-6 border-b border-solid border-darkblue-800"
                    @click="$emit('close')"
                >
                  <button class="btn btn--secondary w-10 h-10 mr-4 !rounded-full">
                    <IconCloseFull/>
                  </button>
                  
                    <span class="text-ch1 !text-darkblue flex items-center">
                      <span>{{title}}</span>
                      <span class="mx-1.5 inline-block">/</span>
                      <span class="mr-1 inline-block"><icon-plus class="w-3 h-3 [&_path]:fill-darkblue"/></span>
                      <span>Info</span>
                    </span>
                </h2>
              
                <div class="overflow-y-scroll">
                    <slot></slot>
                    <div style="height: 50px;"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import IconCloseFull from "./Icons/IconCloseFull.vue";
import IconPlus from "./Icons/IconPlus.vue";

export default {
    name: "SidePopup",
    components: {IconPlus, IconCloseFull},
    props: {
        title: {
            type: String,
            default: ''
        },
        show: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            render: false,
            firstRender: false,
        }
    },
    watch: {
        show(newValue) {
          if ( newValue ) {
              this.firstRender = !this.render;
              this.render = true;
              
              document.body.classList.add("overflow-hidden");
          }
          else {
              document.body.classList.remove("overflow-hidden");
          }
        }
    }
}
</script>

<style scoped lang="scss">
    .first-open {
        animation: first-open .5s ease;
        @keyframes first-open {
            from {
                right: -100%;
            }
            to {
                right: 0;
            }
        }
    }
</style>